import React, { useEffect } from "react";
import MainBg from "@public/img/green-main-bg.png";
import greenCheckIcon from "@public/img/green-check.svg";

type SuccessAlertProps = {
    title: string;
    message: string;
    onClick: () => void;
};

export default function SuccessAlert({
    title,
    message,
    onClick,
}: SuccessAlertProps) {
    useEffect(() => {
        const prev = document.body.style.overflow;
        document.body.style.overflow = "hidden";
        return () => {
            document.body.style.overflow = prev;
        };
    }, []);

    useEffect(() => {
        const onKey = (e: KeyboardEvent) => {
            if (e.key === "Escape") onClick();
        };
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
    }, [onClick]);

    return (
        <div
            className="fixed inset-0 z-30 flex items-center justify-center bg-black/60 p-4 backdrop-blur-md"
            onClick={() => onClick()}
        >
            <img                 src={MainBg}
                alt=""
                className="pointer-events-none absolute inset-0 h-full w-full object-cover opacity-70"
            />
            <div
                dir="rtl"
                className="relative z-10 flex w-full max-w-[400px] flex-col gap-6 rounded-xl bg-bg2 p-5"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="flex w-full flex-col items-center gap-3 text-center">
                    <img                         src={greenCheckIcon}
                        alt=""
                        className="size-20 shrink-0"
                    />
                    <p className="text-xl font-extrabold leading-normal text-lime-400">
                        {title}
                    </p>
                    {title ? (
                        <p className="text-lg font-light leading-normal text-input">{message}</p>
                    ) : null}
                </div>

                <div className="flex w-full items-center gap-2.5">
                    <button
                        type="button"
                        onClick={() => onClick()}
                        className="flex h-9 flex-1 cursor-pointer items-center justify-center rounded-lg border border-lime-400 px-3 text-sm text-lime-400 transition hover:bg-lime-400/10"
                    >
                        ادامه
                    </button>
                </div>
            </div>
        </div>
    );
}
